<template>
  <div>
    <v-app-bar color="#3a3a3a" dark flat fixed>
      <v-toolbar-title>
        <router-link to="/" class="toolbar-title">HP Equipment Calibration</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-speed-dial
        style="right: 20px; top: 10px;"
        fixed
        v-model="fab"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab small>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-btn>
        </template>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              dark
              small
              color="green"
              href="https://hpapps.healthyperformance.co.uk/profile"
              target="_blank"
              v-on="on"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Update profile</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              dark
              small
              color="orange"
              href="https://hpapps.healthyperformance.co.uk/changepassword"
              target="_blank"
              v-on="on"
            >
              <v-icon>mdi-lock-open-outline</v-icon>
            </v-btn>
          </template>
          <span>Change password</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              dark
              small
              color="indigo"
              href="https://hpapps.healthyperformance.co.uk/users"
              target="_blank"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add user</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="red" @click="onSignOut()" v-on="on">
              <v-icon>exit_to_app</v-icon>
            </v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </v-speed-dial>
    </v-app-bar>
    <br/><br/><br/>
    <v-content>
      <slot />
    </v-content>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
export default {
  methods: {
    onSignOut() {
      Auth.signOut()
        .then(data => {
          this.$cookie.delete("AWSTOKEN");
          this.$router.push({ path: "/login" });
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(err => console.log(err));
    },
    onGoToProfile() {
      window.open("https://hpapps.healthyperformance.co.uk/profile");
    }
  },
  data: () => ({
    direction: "bottom",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    transition: "slide-y-reverse-transition"
  }),
  computed: {
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    }
  }
};
</script>
<style>
.toolbar-title {
  color: white !important;
  text-decoration: none;
}
</style>